import React from 'react';

/**
 * Badge for stream count mismatches (expected vs actual).
 * - Warning: expected 2, have 1 (degraded)
 * - Info: expected 1, have 2 (unexpected extra)
 * - Error: expected any, have 0 (down)
 */
const StreamMismatchBadge = ({ expectedStreams, memberCount, className = '' }) => {
  if (memberCount === undefined || memberCount === null) return null;

  let variant = null;
  let label = '';

  if (memberCount === 0) {
    variant = 'error';
    label = '0 streams';
  } else if (expectedStreams === 2 && memberCount === 1) {
    variant = 'warning';
    label = '1 of 2';
  } else if (expectedStreams === 1 && memberCount >= 2) {
    variant = 'info';
    label = `${memberCount} streams`;
  } else if (expectedStreams === 2 && memberCount > 2) {
    variant = 'warning';
    label = '> 2 streams';
  }

  if (!variant) return null;

  const styles = {
    warning: 'bg-amber-500/90 text-amber-950 border-amber-600',
    info: 'bg-blue-500/90 text-blue-950 border-blue-600',
    error: 'bg-red-500/90 text-red-950 border-red-600'
  };

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium border ${styles[variant]} ${className}`}
    >
      {label}
    </span>
  );
};

export default StreamMismatchBadge;
